/* eslint-disable linebreak-style */
/* eslint-disable import/extensions */
/* eslint-disable max-len */
/* eslint-disable react/jsx-filename-extension */
import React from "react";

export default function Tcs() {
  return (
    <section className="hero sm:items-center lg:items-start sm:flex-row mb-12">
      <div className="w-full flex flex-col px-5 mb-5 sm:mb-0 sm:px-12 sm:mt-6 lg:mt-12">
        <h2 className="text-5xl text-theme-blue text-center font-bold leading-tight mb-4 dark:text-white">
          Nube iO Group Terms and Conditions
        </h2>
        <div className="my-6 w-full border-t-4 border-theme-teal" />
        <div className="space-y-6">
          <h3 className="text-2xl font-bold text-theme-blue dark:text-white mt-12">
            <strong>Nube iO Group Terms and Conditions</strong>
          </h3>
          <h4 className=" text-lg lg:text-xl font-bold text-theme-blue dark:text-theme-teal">
            <strong>Structure of the agreement </strong>
          </h4>
          <p className="text-base  font-light text-gray-400 leading-relaxed mb-6">
            This agreement comprises:
          </p>
          <ul className="list-inside list-disc text-base font-light text-gray-400 mb-6">
            <li>These Terms and Conditions;</li>
            <li>The Services Description and/or the Product Description</li>
            <li>One or more Orders; and</li>
            <li>
              Any other document that is expressly incorporated into this
              agreement.
            </li>
          </ul>
          <h4 className=" text-lg lg:text-xl font-semibold text-theme-teal">
            <strong>1. COMMENCEMENT AND TERM</strong>
          </h4>
          <ol className="list pl-6 text-base font-light text-gray-400 mb-6">
            <li>
              1.1 This agreement comes into force on the date that we confirm
              that we have accepted your Order.
            </li>
            <li>
              1.2 This agreement continues until terminated in accordance with
              clause 15.
            </li>
          </ol>
          <h4 className="  text-lg lg:text-xl font-bold text-theme-teal ">
            <strong>2. WHAT WE WILL SUPPLY</strong>
          </h4>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            We will, in accordance with the terms of this agreement, supply the
            Products and the Services.
          </p>
          <h4 className=" text-lg lg:text-xl font-semibold text-theme-teal">
            <strong>3.OUR STANDARDS</strong>
          </h4>
          <ol className="list text-base pl-4 font-light text-gray-400 leading-relaxed mb-6">
            <li>3.1 We will use our reasonable endeavours to:</li>
            <li>
              3.1.1 supply the Products and the Services and perform our other
              obligations under this agreement, in a diligent and professional
              manner; and
            </li>
            <li>
              3.1.2 ensure that, in providing the Products and the Services, we
              comply with all applicable Laws, including any requirement to hold
              any Authorisation.
            </li>
            <li>
              3.2 We do not guarantee that the supply of Services will be
              continuous or free of interruptions.
            </li>
            <li>
              3.3 You acknowledge that the purpose of the Service Levels is to
              specify the minimum standards of performance we try to achieve in
              supplying the Services. We do not guarantee that we will achieve
              the Service Levels at all times.
            </li>
            <li>
              3.4 We are not a Carrier and do not supply Carriage Services. We
              are a reseller and may arrange for you to be supplied with
              Carriage Services by a Carrier or a Carriage Service Provider.
              Accordingly, you acknowledge and agree that we are not responsible
              for any:
            </li>
            <li>
              3.4.1 act or omission of any Carrier or Carriage Service Provider
              who we arrange to supply Carriage Services to you; and
            </li>
            <li>
              3.4.2 interruption in, disruption to or suspension by a Carrier or
              Carriage Service Provider of the Carriage Services supplied to
              you.
            </li>
            <li>
              3.5 You acknowledge that the internet is sometimes unreliable and
              is difficult to secure and we do not guarantee:
            </li>
            <li>
              3.5.1 the security of Our System, the interfaces you use to
              connect to Our System or the information that passes through or is
              stored in Our System;
            </li>
            <li>
              3.5.2 access to Our System will be continuous, accessible at all
              times or fault free; or
            </li>
            <li>3.5.3 that Our System is free of Viruses.</li>
          </ol>
          <h2 className="text-lg lg:text-xl text-theme-teal font-semibold ">
            <strong>4. HOW TO ORDER PRODUCTS AND SERVICES</strong>
          </h2>
          <ol className="list text-base pl-4 font-light text-gray-400 leading-relaxed mb-6">
            <li>
              4.1 You may at any time request us to supply a Product or a
              Service by submitting an Order.
            </li>
            <li>
              4.2 An Order is not binding upon us until we have issued a notice
              to you of our acceptance of that Order. Any acknowledgement of
              receipt by or on our behalf of any Order will not constitute
              acceptance of that Order.
            </li>
            <li>
              4.3 Once we have accepted an Order, you are not entitled to cancel
              that Order or return any Product due to a change of mind without
              our prior written consent which we may or may not grant in our
              absolute discretion and on any terms we may decide including:
            </li>
            <li>4.3.1 charging a cancellation or return fee;</li>
            <li>
              4.3.2 requiring you to organise and pay for all return shipping
              costs;
            </li>
            <li>
              4.3.3 requiring any Product to be in its original condition
              including packaging.
            </li>
          </ol>

          <h4 className="text-lg lg:text-xl text-theme-teal font-semibold ">
            <strong>5. PRODUCT DELIVERY, TITLE AND RISK</strong>
          </h4>
          <ol className="list pl-4 text-base font-light text-gray-400 leading-relaxed mb-6">
            <li>
              5.1 All Product deliveries will be made Ex-Works at Nube iO’s
              premises in Helensburgh (Incoterms 2020)]. All customs duty,
              freight and insurance from the point of delivery will be your
              responsibility and at your cost.
            </li>
            <li>
              5.2 You must inspect all delivered Products and give notice to us
              within 5 Business Days of delivery if the Products are defective
              or not in accordance with your Order. If you do not give us this
              notice, then, subject to any non-excludable condition or guarantee
              implied by Law, the Products will be deemed to have been delivered
              to and accepted by you.
            </li>
            <li>
              5.3 Title to Products passes to you upon payment in full and risk
              of loss passes to you upon deliver.
            </li>
            <li>
              5.4 Until full payment for Products has been received by us, such
              Products will be subject to a security interest in favour of us or
              our nominee and we or our nominee may register such security
              interest or take any other such action as they determine in order
              to secure such interest and you must execute all documents and
              take any other actions as reasonably directed by us or our nominee
              in order to create, protect and preserve such security interest.
            </li>
            <li>
              5.5 We may cancel or delay deliver in accordance with an Order
              that has previously been accepted in times ofClaro, aquí tienes la
              continuación del código con la indentación ajustada: JavaScript
              shortage, due to supply chain constrains or due to Force Majeure.
              Any such cancellation or delay will not constitute a breach of
              this agreement by us.
            </li>
          </ol>

          <h4 className="text-lg lg:text-xl text-theme-teal  font-semibold ">
            <strong>6. YOUR OBLIGATIONS</strong>
          </h4>
          <ol className="list text-base pl-4 font-light text-gray-400 leading-relaxed mb-6">
            <li>
              6.1 You must ensure that all equipment connected by you to the
              Products or the Services, or on your behalf, complies with the
              specifications for equipment that is capable of connecting safely
              with the Products and the Services and also complies with the Data
              Sheet and the User Manual for each relevant Product as set out on
              Our Website.
            </li>
            <li>
              6.2 You must not alter, tamper with, repair or attempt to repair
              the Products or the Services or allow a third party (other than an
              accredited technician approved by us) to do any of these things.
            </li>
            <li>6.3 You are solely responsible for:</li>
            <li>
              6.3.1 choosing, acquiring and maintaining your own equipment,
              facilities and systems necessary to enable you to use the Products
              and the Services effectively, efficiently and safely;
            </li>
            <li>
              6.3.2 ensuring that the Products and the Services are compatible
              with your networks and systems;
            </li>
            <li>
              6.3.3 the consequences of using the Products and the Services; and
            </li>
            <li>
              6.3.4 the security of data or information that you send, receive
              or store using the Products or the Services.
            </li>
            <li>
              6.4 You must use your best endeavours to ensure that no Virus is
              introduced into Our System.
            </li>
            <li>6.5 You must comply with:</li>
            <li>6.5.1 all applicable Laws; and</li>
            <li>
              6.5.2 Our Policies to the extent that they relate to the Products
              and the Services.
            </li>
            <li>
              6.6 If we require access to your premises in connection with the
              performance of our obligations under this agreement, you will,
              subject to your usual security requirements, provide us with
              reasonable access to your premises at such times as may be
              reasonably necessary to enable us to perform our obligation under
              this agreement. Such access will include the right for us to use
              all existing building services.
            </li>
            <li>
              6.7 When we enter your premises, we will use our reasonable
              endeavours to:
            </li>
            <li>6.7.1 protect people and property;</li>
            <li>
              6.7.2 prevent nuisance and unnecessary noise and disturbance; and
            </li>
            <li>
              6.7.3 act in a safe and Lawful manner and comply with your safety
              standards and policies as notified to us.
            </li>
            <li>
              6.8 You represents that, to the best of your knowledge, if we are
              required to install any Products at your premises that the
              structure of the premises or equipment in or upon which the
              Products are to be installed is sound and will sustain the
              installation and any incidental work and we will not be liable for
              any claims, demands, losses, damages, costs or expenses caused or
              arising in connection with the installation and any incidental
              work.
            </li>
            <li>
              6.9 You represents that, to the best of your knowledge, there is
              no asbestos or hazardous material on your premises that will in
              any way affect our personnel or the performance of our obligations
              under this agreement. If you become aware of or suspect the
              presence of asbestos or hazardous materials, you must immediately
              notify us, or if we become aware of or suspect the presence of
              asbestos or hazardous materials, we may stop work in the affected
              area and you must do whatever is necessary to correct the
              condition in accordance with all applicable Laws. You must also
              indemnify us against any claims made against us arising out of or
              relating to the presence of asbestos or hazardous materials.
            </li>
          </ol>

          <h4 className="text-lg lg:text-xl text-theme-teal  font-semibold ">
            <strong>7. YOU GRANT US A SECURITY INTEREST</strong>
          </h4>
          <ol className="list text-base pl-4 font-light text-gray-400 leading-relaxed mb-6">
            <li>
              7.1 You acknowledge and agree that this agreement constitutes a
              ‘Security Agreement’ for the purposes of the PPSA and creates a
              Security Interest of ours in the Products and all things produced
              for or in connection with the performance of the Services.
            </li>
            <li>
              7.2 By notice to you, we may require you to take all steps or do
              any other thing that we consider necessary to ensure that this
              agreement or any Security Interest arising under this agreement,
              is enforceable against you or any third party or to protect,
              perfect, record or better secure, or obtain or preserve the
              priority of, our security position under this agreement. You must
              comply with the requirements of such a notice within the time
              stated in the notice at your cost.
            </li>
            <li>
              7.3 You waive any rights to receive a verification statement. To
              the extent that Chapter 4 of the PPSA would otherwise apply to
              enforcement by us of any Security Interest in collateral, the
              parties agree that, to the extent the PPSA allows, sections 125,
              132(3)(d), 132(4), 135, 142 and 143 of the PPSA do not apply.
            </li>
          </ol>

          <h4 className="text-lg lg:text-xl text-theme-teal  font-semibold ">
            <strong>8. PAYMENTS OF THE CHARGES AND INVOICES</strong>
          </h4>
          <ol className="list text-base pl-4 font-light text-gray-400 leading-relaxed mb-6">
            <li>
              8.1 You must pay us the Charges for the Products and the Services.
            </li>
            <li>
              8.2 We may change the Charges for any Product or Service at any
              time by giving you not less than 30 days’
            </li>
            <li>
              8.3 We may offer you a discount to our Charges or our Charges may
              include a volume discount. If we offer a discount, we may revoke
              or change the discount at any time by giving you not less than 30
              days’ notice of the revocation or change or, if you are in breach
              of this agreement, immediately without giving you notice.
            </li>
            <li>
              8.4 We will invoice you for the Charges. We may invoice you at any
              time for a Product or a Service. We may invoice you monthly,
              quarterly or yearly in advance for the Charges for a Data Plan.
            </li>
            <li>
              8.5 We may include in an invoice Charges that relate to a Product
              or a Service supplied in a period prior to the period to which the
              invoice relates, even if, in the case of a Service, that Service
              has been cancelled orClaro, aquí tienes la continuación del código
              con la indentación ajustada: JavaScript suspended.
            </li>
            <li>8.6 We may issue invoices by email.</li>
            <li>
              8.7 You must pay the amount of our invoice by the due date
              specified in the invoice.
            </li>
            <li>
              8.8 We may charge you a fee for using a payment method. We may
              also charge you for any taxes, duties, costs, charges, fees or
              expenses we incur as a result of the payment method you use.
            </li>
            <li>
              8.9 Any claim by you that an invoice is incorrect must be made
              before the due date for payment of that invoice.
            </li>
            <li>
              8.10 If you fail to make a payment on the due date, we may charge
              you interest at the interest rate our bank charges for a business
              overdraft on the due date. Interest accrues daily from the due
              date until the date you make payment in full. You must pay us
              interest when we invoice you for it.
            </li>
          </ol>

          <h4 className="text-lg lg:text-xl text-theme-teal  font-semibold ">
            <strong>9. GST</strong>
          </h4>
          <ol className="list text-lg pl-4 font-light text-gray-400 leading-relaxed mb-6">
            <li>
              9.1 Words defined in the GST Law have the same meaning in this
              clause 9, unless the context makes it clear that a different
              meaning is intended.
            </li>
            <li>
              9.2 Unless indicated otherwise, the Charges and all other amounts
              referred to in this agreement are stated exclusive of GST. If GST
              is or will be imposed on a supply made under or in connection with
              this agreement, to the extent that the consideration otherwise
              provided for that supply under this agreement is not stated to
              include an amount in respect of GST on the supply:
            </li>
            <li>
              9.2.1 the consideration otherwise provided for that supply is
              increased by the amount of that GST; and
            </li>
            <li>
              9.2.2 the recipient must make payment of the increase at the same
              time as the consideration is provided subject to receipt of a tax
              invoice.
            </li>
            <li>
              9.3 The supplier of a taxable supply under this agreement will
              issue a tax invoice or adjustment note to the recipient in
              relation to the supply.
            </li>
          </ol>
          <h4 className="text-lg lg:text-xl text-theme-teal  font-semibold ">
            <strong>10. PRODUCT WARRANTIES</strong>
          </h4>
          <ol className="list text-base pl-4 font-light text-gray-400 leading-relaxed mb-6">
            <li>
              10.1 Our Warranty Policy applies to the Products supplied under
              this agreement which are manufactured by us.
            </li>
            <li>
              10.2 Non–Nube iO branded products purchased from Nube iO may be
              eligible for coverage under the Australian Consumer Law but they
              are not covered by our Warranty Policy. We do not give you any
              warranty, expressed or implied, for non–Nube iO branded products.
              If the manufacturer of a non–Nube iO branded product provides an
              assignable warranty relating to that product (“Product Warranty”),
              we will notify you of the Product Warranty and assign it to you to
              the extent permitted by such Product Warranty and any applicable
              law. If you consider that any non–Nube iO branded product we
              supply to you is defective, you must notify us of the defect in
              accordance with the terms of the Product Warranty. If you give us
              such notice, we will use our reasonable endeavours to assist you
              to make a claim under the Product Warranty. You are responsible
              for the cost of returning any non–Nube iO branded product for
              repair or replacement under a Product Warranty including labour
              costs, freight, taxes and any other direct or indirect cost.
            </li>
            <li>
              10.3 If there is a manufacturing defect with a SIM Card we supply
              you, we will replace the SIM Card free of charge or refund you the
              cost of the SIM Card.
            </li>
          </ol>

          <h4 className="text-lg lg:text-xl text-theme-teal font-semibold ">
            <strong>11. CONFIDENTIALITY</strong>
          </h4>
          <ol className="list text-base pl-4 font-light text-gray-400 leading-relaxed mb-66">
            <li>
              11.1 Obligation of confidentiality. In addition to any obligations
              under this agreement or in respect of secret and confidential
              information at Law, each party undertakes and agrees:
            </li>
            <li>
              11.1.1 to hold in strict confidence all Confidential Information
              and not to disclose or permit or cause the Confidential
              Information to be disclosed to any person other than any of its
              personnel who require the Confidential Information for the
              purposes of this agreement; and
            </li>
            <li>
              11.1.2 not to make use of the Confidential Information, except and
              solely to the extent necessary for the purposes of this agreement,
              unless either party has obtained the prior written consent of the
              other party to do so, which may be withheld by the other party in
              its absolute discretion or given on such terms as it sees fit. You
              must use your best endeavours to ensure that your personnel
              undertake and agree to comply with the obligations set out in this
              clause with respect to any Confidential Information of ours
              disclosed to them by us or you.
            </li>
            <li>11.2 Exceptions. Clause 11.1 does not apply to:</li>
            <li>
              11.2.1 information after it becomes generally available to the
              public other than as a result of a breach of confidence or a
              breach of this agreement;
            </li>
            <li>
              11.2.2 the disclosure of information in connection with legal
              proceedings relating to this agreement; or
            </li>
            <li>
              11.2.3 the disclosure of information to comply with any applicable
              Law or rule of a recognised securities exchange, provided that
              prior to such disclosure the party proposing to disclose gives
              notice to the other party with full particulars of the proposed
              disclosure.
            </li>
            <li>
              11.3 Public announcements. Except as required by any applicable
              Law or as otherwise permitted by this agreement, you may not make
              any public announcements or disclosures as to this agreement or
              otherwise inClaro, aquí tienes la continuación del código con la
              indentación ajustada: JavaScript relation to the subject matter of
              this agreement without our prior written consent.
            </li>
            <li>
              11.4 Return or destruction of Information. If requested by either
              party, whether prior to or after the expiry or earlier termination
              of this agreement, the other party must promptly deliver to the
              requesting party or destroy (at the discretion of the requesting
              party) all Confidential Information in the custody, possession or
              control of the other party or any of its personnel.
            </li>
          </ol>

          <h4 className="text-lg lg:text-xl text-theme-teal  font-semibold ">
            <strong>12. PRIVACY</strong>
          </h4>
          <ol className="list text-base pl-4 font-light text-gray-400 leading-relaxed mb-6">
            <li>
              12.1 You agree that we may obtain from a credit reporting agency a
              credit report containing personal credit information about you in
              relation to credit provided by us.
            </li>
            <li>
              12.2 You agree that we may exchange information about you with
              those credit providers either named as trade referees by you or
              named in a consumer credit report issued by a credit reporting
              agency for the following purposes:
            </li>
            <li>12.2.1 to assess an application by you;</li>
            <li>
              12.2.2 to notify other credit providers of a default by you;
            </li>
            <li>
              12.2.3 to exchange information with other credit providers as to
              the status of this credit account, where you are in default with
              other credit providers; and/or
            </li>
            <li>
              12.3 You acknowledge that the information exchanged can include
              anything about your creditworthiness, credit standing, credit
              history or credit capacity that credit providers are allowed to
              exchange under the Privacy Act 1988.
            </li>
            <li>
              12.4 You consent to us being given a consumer credit report to
              collect overdue payment on commercial credit.
            </li>
            <li>
              12.5 You agree that personal credit information provided may be
              used and retained by us for the following purposes (and for other
              purposes as we both agree or as required by Law from time to
              time):
            </li>
            <li>12.5.1 the provision of Products or Services;</li>
            <li>
              12.5.2 the marketing of Products or Services by us, our agents or
              distributors;
            </li>
            <li>
              12.5.3 analysing, verifying and/or checking your credit, payment
              and/or status in relation to the provision of Products or
              Services;
            </li>
            <li>
              12.5.4 processing of any payment instructions, direct debit
              facilities and/or credit facilities requested by your; and/or
            </li>
            <li>
              12.5.5 enabling the daily operation of your account and/or the
              collection of amounts outstanding in your account in relation to
              the Products or Services.
            </li>
            <li>
              12.6 We may give information about you to a credit reporting
              agency for the following purposes:
            </li>
            <li>12.6.1 to obtain a consumer credit report about you; and/or</li>
            <li>
              12.6.2 allow the credit reporting agency to create or maintain a
              credit information file containinginformation about you.
            </li>
            <li>
              12.7 The information given to the credit reporting agency may
              include:
            </li>
            <li>
              12.7.1 personal particulars (name, sex, address, previous
              addresses, date of birth, name of employer and driver’s licence
              number);
            </li>
            <li>
              12.7.2 details concerning your application for credit or
              commercial credit and the amount requested;
            </li>
            <li>12.7.3 advice that we are a current credit provider to you;</li>
            <li>
              12.7.4 advice of any overdue accounts, loan repayments, and/or any
              outstanding monies owing which are overdue by more than 60 days,
              and for which debt collection action has been started;
            </li>
            <li>
              12.7.5 that your overdue accounts, loan repayments and/or any
              outstanding monies are no longer overdue in respect of any default
              that has been listed;
            </li>
            <li>
              12.7.6 information that, in our opinion, you have committed a
              serious credit infringement (that is, fraudulently or shown an
              intention not to comply with your credit obligations);
            </li>
            <li>
              12.7.7 advice that cheques drawn by you for $100 or more, have
              been dishonoured more than once; and/or
            </li>
            <li>
              12.7.8 that credit provided to you by us has been paid or
              otherwise discharged.
            </li>
          </ol>
          <h4 className="text-lg lg:text-xl text-theme-teal  font-semibold ">
            <strong>13. YOUR INDEMNITY</strong>
          </h4>
          <ol className="list pl-6 text-base font-light text-gray-400 mb-6">
            <li>
              13.1 You indemnify us against all Loss we suffer or incur as a
              result of or relating to:
            </li>
            <li>
              13.1.1 the injury (including mental illness) or death of any
              person;
            </li>
            <li>
              13.1.2 Loss of or damage to our property or the property of a
              third party;
            </li>
            <li>
              13.1.3 an infringement or alleged infringement of a third party’s
              IP or Moral Rights; or
            </li>
            <li>13.1.4 your use of the Products or the Services,</li>
            <li>
              where the Loss arises out of or as a consequence of your Default.
            </li>
            <li>
              13.2 The amount payable under the indemnity in clause 13.1 is
              reduced to the extent that the Loss is caused or contributed to by
              our Default.
            </li>
          </ol>

          <h4 className="text-lg lg:text-xl text-theme-teal  font-semibold ">
            <strong>14. LIMITS ON OUR LIABILITY</strong>
          </h4>
          <ol className="list text-base pl-4 font-light text-gray-400 leading-relaxed mb-6">
            <li>
              14.1 To the fullest extent permitted by Law, all terms which might
              be implied by statute are excluded and our liability for any Claim
              relating to the Products or Services, whether pursuant to
              contract, tort, statute law or otherwise, is limited to Our
              Warranty Policy.
            </li>
            <li>
              14.2 Notwithstanding anything else in this agreement, our
              liability under this agreement, whether arising under contract
              (including under any indemnity or warranty), tort, Law or
              otherwise will not exceed:
            </li>
            <li>
              14.2.1 for the full term of this agreement, the amounts paid to us
              by you over the life of this agreement, in aggregate; or
            </li>
            <li>
              14.2.2 for a single event, the amounts paid to us by you up to the
              date of that event.
            </li>
            <li>
              14.3 Notwithstanding any other provision of this agreement, except
              for a party’s breach of its Confidentiality Information
              obligations or your breach of clause 6.9 (relating to asbestos and
              hazardous materials) or clause 13 (Your Indemnity), neither party
              will be liable (including under any warranty) to the other party,
              its Affiliates or its officers, directors, employees and agents
              whether under contract, tort, Law or otherwise for:
            </li>
            <li>
              14.3.1 any loss of use, profit, production, revenue, future sales,
              anticipated savings, goodwill, data, opportunity (present or
              future) or reputation;
            </li>
            <li>14.3.2 interruption to any business; or</li>
            <li>14.3.3 any special, indirect or consequential losses,</li>
            <li>
              that the other party or the other party’s Affiliates may incur or
              suffer in connection with this agreement.
            </li>
          </ol>

          <h4 className="text-lg lg:text-xl text-theme-teal  font-semibold ">
            <strong>
              15. HOW THIS AGREEMENT MAY BE TERMINATED OR SUSPENDED
            </strong>
          </h4>
          <ol className="list text-base pl-4 font-light text-gray-400 leading-relaxed mb-6">
            <li>
              15.1 Suspension. We may immediately suspend the performance of any
              or all of our obligations under any Order that we have previously
              accepted or otherwise under this agreement, by notice in writing
              to you if:
            </li>
            <li>15.1.1 you are in breach of this agreement;</li>
            <li>15.1.2 in an emergency;</li>
            <li>
              15.1.3 the supply or use of a Product or a Service becomes
              unlawful;
            </li>
            <li>
              15.1.4 you fail to make any payment to us when due under this
              agreement;
            </li>
            <li>
              15.1.5 you use a Product or a Service to commit an offence or
              allow anyone else to do so;
            </li>
            <li>
              15.1.6 your use of a Product or a Service interferes with or
              disrupts Our System or the efficiency of Our System;
            </li>
            <li>
              15.1.7 the Carrier who supplies the Carriage Service that we
              arrange to be supplied to you cancels or suspends or asks or
              directs us to cancel or suspend the Carriage Service; or
            </li>
            <li>
              15.1.8 our ability to supply a Product or a Service is impacted by
              Force Majeure.
            </li>
            <li>
              We may at any time recommence the performance of any obligations
              suspended pursuant to this clause.
            </li>
            <li>
              15.2 Termination. Either party may terminate this agreement:
            </li>
            <li>
              15.2.1 upon 60 day’s advance written notice to the other party if
              the other party breaches the terms of this agreement and fails to
              remedy such breach within such 60 day period;
            </li>
            <li>
              15.2.2 immediately by notice in writing to the other party if it
              is in breach of its obligations under clause 11 (Confidentiality);
              o
            </li>
            <li>
              15.2.3 if Force Majeure prevents the performance of a party’s
              obligations under this agreement for more than 14 days, by written
              notice to the other party.
            </li>
            <li>
              15.3 Termination by us. In addition to our right to terminate
              under clause 15.2 or otherwise at Law, we may terminate this
              agreement and/or any Order previously accepted by us:
            </li>
            <li>
              15.3.1 upon 21 days’ advance written notice to you if we have
              suspended our performance in accordance with clause 15.1 and we
              have not recommenced the performance of all or some of those
              obligations;
            </li>
            <li>15.3.2 upon 30 days’ advance written notice to you:</li>
            <li>(i) if an Insolvency Event occurs in respect of you; or</li>
            <li>
              (ii) if there is a Change of Control with respect to you or your
              direct or indirect parent which results in you being Controlled
              by, in our reasonable opinion, a competitor of ours;
            </li>
            <li>
              15.3.3 immediately by notice in writing to you if we, in our
              absolute discretion, are of the opinion that you or your
              employees, have condoned and/or have engaged in conduct that is
              corrupt or fraudulent or have failed to comply with any Law; or
            </li>
            <li>15.3.4 immediately by notice in writing upon:</li>
            <li>(i) criminal conviction;</li>
            <li>(ii) debarment;</li>
            <li>
              (iii) indictment or other charge of violating criminal Laws;
            </li>
            <li>
              (iv) ineligibility to contract with or to receive a license or
              other form of authorization from a Government Agency; or
            </li>
            <li>
              (v) denial, suspension or revocation of eligibility to be involved
              in exports, imports or to conduct business by you or your
              Affiliate.
            </li>
            <li>
              15.4 Termination by you. You may, by written notice to us,
              terminate this agreement for convenience with effect from a date
              specified in the notice (being a date not less than 30 days after
              the date of the notice) and which includes termination of any Data
              Plan in accordance with its terms and conditions. If an early
              termination fee is specified in the Service Description of a
              Service, you must pay us the early termination fee if you
              terminate this agreement for convenience.
            </li>
            <li>
              15.5 The suspension, expiration or termination of this agreement
              does not affect any rights, liabilities or obligations of the
              parties arising before such suspension, expiration or termination
              including our right to recover any Charges incurred on your behalf
              with a third-party service provider for which we are invoiced
              after the date of expiration or termination of this agreement.
            </li>
          </ol>

          <h4 className="text-lg lg:text-xl text-theme-teal  font-semibold ">
            <strong> 16. HOW THIS AGREEMENT MAY BE VARIED</strong>
          </h4>
          <ol className="list text-base pl-4 font-light text-gray-400 leading-relaxed mb-6">
            <li>
              16.1 This agreement may be varied, amended or supplemented in
              writing, signed by each party.
            </li>
            <li>
              16.2 We may also change this agreement at any time subject to
              giving you at least 14 days’ notice of the change. If you do not
              accept the change you may, within 14 days of receiving our notice,
              ask us to close your account and terminate this agreement.
            </li>
            <li>
              16.3 For the purposes of clause 16.2, a change to this agreement
              includes:
            </li>
            <li>
              16.3.1 any termination of a service or a change of terms of
              service by a Carrier or Carriage Service Provider who we arrange
              to supply Carriage Services to you directly or indirectly; and
            </li>
            <li>16.3.2 any change or addition to Our Policies.</li>
          </ol>
          <h4 className="text-lg lg:text-xl text-theme-teal  font-semibold ">
            <strong>17. INTELLECTUAL PROPERTY</strong>
          </h4>
          <ol className="list text-base pl-4 font-light text-gray-400 leading-relaxed mb-6">
            <li>17.1 The parties agree that:</li>
            <li>
              17.1.1 the Intellectual Property of a party existing prior to the
              date of this agreement remains the sole and exclusive property of
              that tarty; and
            </li>
            <li>
              17.1.2 the right, title and interest in any Intellectual Property
              created by the provision of the Products or the Services by us is
              vested in us.
            </li>
            <li>17.2 You must:</li>
            <li>
              17.2.1 assign all right, title and interest in any Intellectual
              Property referred to in clause 17.1.2 to us or as directed by us;
            </li>
            <li>
              17.2.2 provide to us with all reasonable assistance requested to
              protect that Intellectual Property; and
            </li>
            <li>
              17.2.3 not permit any person reasonably within your control nor
              procure any person to modify, copy, clone or reverse engineer the
              Products or the Services or copy, modify, decompile any of our
              documentation relating to the Products or the Services.
            </li>
          </ol>
          <h4 className="text-lg lg:text-xl text-theme-teal  font-semibold ">
            <strong>18. TRADEMARKS</strong>
          </h4>
          <ol className="list text-base pl-4 font-light text-gray-400 leading-relaxed mb-6">
            <li>
              18.1 Both parties acknowledge that each parties’ patents,
              trademarks, copyrights, brand names and trade names (whether
              registered or not) are the sole property of that party and agrees
              to cooperate in the protection thereof.
            </li>
            <li>
              18.2 You must not remove our trademarks or brand names from any
              Products or materials furnished by us or affix any additional
              trademarks, logos or trade designations to any such Product or
              materials.
            </li>
            <li>
              18.3 All rights in our trademarks and brand names must, at all
              times, be and remain our sole property, and all good will and
              other benefits associated with them are assigned to, and will
              inure to, us.
            </li>
            <li>
              18.4 You must not assign, sublicense, make available or otherwise
              transfer any right to use, develop or otherwise enjoy any such
              trademarks and brand names without our prior written consent.
            </li>
            <li>
              18.5 You must not make any use of our trademarks or brand names
              with any products or services not furnished by us, or in any
              manner which would injure or destroy their value and you must not
              make use in your business of any other trademarks or brand names
              likely to be confused with our trademarks and brand names.
            </li>
          </ol>

          <h4 className="text-lg lg:text-xl text-theme-teal  font-semibold ">
            <strong>19. PRECEDENCE AND INTERPRETATION</strong>
          </h4>
          <ol className="list text-base pl-4 font-light text-gray-400 leading-relaxed mb-6">
            <li>
              19.1 If there is any inconsistency between provisions of this
              agreement, a descending order of precedence is to be accorded to:
            </li>
            <li>19.1.1 these Terms and Conditions;</li>
            <li>19.1.2 a Service Description or a Product Description;</li>
            <li>19.1.3 an Order; and</li>
            <li>
              19.1.4 a provision of another document that is expressly
              incorporated into this agreement,
            </li>
            <li>
              so that the higher ranked provision prevails to the extent of the
              inconsistency.
            </li>
            <li>
              19.2 Additional terms and conditions in any Order or any terms and
              conditions in an Order which are inconsistent with this agreement,
              will not apply to this agreement or any Order and we will not be
              bound by any such terms or conditions.
            </li>
            <li>
              19.3 In this agreement, the following rules of interpretation
              apply, unless the contrary intention appears or context otherwise
              requires:
            </li>
            <li>
              (a) headings and subheadings are for convenience only and do not
              affect the interpretation;
            </li>
            <li>
              (b) references to clauses, schedules, annexures, appendices,
              attachments and exhibits are references to the clauses of, and the
              schedules, annexures, appendices, attachments and exhibits to,
              this agreement;
            </li>
            <li>
              (c) references to parties are references to the parties to this
              agreement;
            </li>
            <li>
              (d) references to a party to any agreement or document include
              that party’s permitted assignees and successors, including
              executors and administrators and legal representatives;
            </li>
            <li>
              (e) words denoting the singular include the plural and words
              denoting the plural include the singular;
            </li>
            <li>(f) words denoting any gender include all genders;</li>
            <li>
              (g) the word ‘person’ includes any individual, corporation or
              other body corporate, partnership, joint venture, trust,
              association and any Government Agency, whether or not it comprises
              a separate legal entity;
            </li>
            <li>
              (h) a reference to any agreement or document includes any
              amendments to or replacements of that document;
            </li>
            <li>
              (i) any promise, agreement, representation or warranty given or
              entered into on the part of two or more persons binds them jointly
              and each of them severally;
            </li>
            <li>
              (j) any promise, agreement, representation or warranty given or
              entered into on the part of two or more persons is for the benefit
              of them jointly and each of them severally;
            </li>
            <li>
              (k) no provision of this agreement will be construed adversely to
              a party because that party was responsible for the preparation of
              that provision;
            </li>
            <li>
              (l) if a period of time begins on a given day or the day of an act
              or event, it is to be calculated exclusive of that day;
            </li>
            <li>
              (m) a reference to time is a reference to Sydney, New South Wales
              time unless otherwise specified;
            </li>
            <li>
              (n) a reference to a day is to be interpreted as the period of
              time commencing at midnight and ending 24 hours later;
            </li>
            <li>
              (o) if any act is required to be performed under this agreement by
              a party on or by a specified day and the act is performed after
              5.00pm on that day, the act is deemed to be performed on the next
              day;
            </li>
            <li>
              (p) if any act is required to be performed under this agreement on
              or by a specified day and that day is not a Business Day, the act
              must be performed on or by the next Business Day;
            </li>
            <li>
              (q) a reference to an amount of dollars, Australian dollars, $ or
              A$ is a reference to the lawful currency of the Commonwealth of
              Australia, unless the amount is specifically denominated in
              another currency;
            </li>
            <li>
              (r) terms ‘include’, ‘including’, ‘includes’, ‘for example’, ‘such
              as’ or any similar expression does not limit the sense of the
              words; and
            </li>
            <li>
              (s) where a word or phrase is defined, other parts of speech and
              grammatical forms of that word or phrase have corresponding
              meanings.
            </li>
          </ol>

          <h4 className="text-lg lg:text-xl text-theme-teal  font-semibold ">
            <strong>20. OTHER TERMS</strong>
          </h4>
          <ol className="list text-base pl-4 font-light text-gray-400 leading-relaxed mb-6">
            <li>
              20.1 The parties agree that, except as may be required by law, the
              express provisions of this agreement are intended to constitute
              the exhaustive statement of their rights and obligations in
              relation to the Products and the Services and the other matters to
              which it relates.
            </li>
            <li>
              20.2 An indemnity granted to a person under this agreement is in
              addition to, and does not replace or limit any other right the
              person may have under this agreement or otherwise at law.
            </li>
            <li>
              20.3 You are an independent contractor and the relationship
              between the parties created by this agreement is solely of buyer
              and seller. You must not make any representation or warranty on
              behalf of us, about us or about the Services or the Products.
            </li>
            <li>20.4 Nothing in this agreement:</li>
            <li>
              20.4.1 gives a party authority to bind the other party in any way
              either expressed or implied;
            </li>
            <li>
              20.4.2 creates a relationship between the parties of principal and
              agent or employer and employee; or
            </li>
            <li>
              20.4.3 imposes any fiduciary duties on a party in relation to the
              other party.
            </li>
            <li>
              20.5 Assignment. The benefit of this agreement must not be
              assigned by you without our prior written consent.
            </li>
            <li>
              20.6 Compliance. You must comply with all applicable Laws relating
              to your performance of this agreement. You, including your
              officers, directors, employees and agents, must use only
              legitimate, legal and ethical business practices to perform this
              agreement.
            </li>
            <li>
              20.7 Counterparts. This agreement may be executed in any number of
              counterparts. All of those counterparts taken together are deemed
              to constitute one and the same instrument.
            </li>
            <li>
              20.8 No merger. On expiry or termination of this agreement, the
              rights and obligations of the parties set out in this agreement
              will not merge and any provision that has not been fulfilled
              remains in force.
            </li>
            <li>
              20.9 Survival.Clauses 11 (Confidentiality), 14 (Limits on Our
              Liability), 17 (Intellectual Property), 19 (Precedence and
              Interpretation), 25 (Governing Law), 26 (Dispute Resolution) and
              27 (Glossary), survive termination or expiry of this agreement
              together with any other term which by its nature is intended to do
              so.
            </li>
            <li>
              20.10 Further action. Each party must at its own expense do all
              things (including completing and signing all documents) reasonably
              requested by the other party that are necessary to:
            </li>
            <li>
              20.10.1 bind the party and any other person intended to be bound
              by this agreement; and
            </li>
            <li>
              20.10.2 give full effect to this agreement and the transactions
              contemplated by this agreement,
            </li>
            <li>
              and use all reasonable endeavours to procure that any third
              parties do the same.
            </li>
            <li>
              20.11 Remedies cumulative. Except as provided in this agreement
              and permitted by Law, the rights, powers and remedies provided in
              this agreement are cumulative with and not exclusive to the
              rights, powers or remedies provided by Law independently of this
              agreement.
            </li>
            <li>
              20.12 Entire agreement. This agreement states all the express
              terms agreed by the parties about its subject matter. It
              supersedes all prior agreements, understandings, negotiations and
              discussions in respect of its subject matter.
            </li>
            <li>
              20.13 No reliance. No party has relied on any statement,
              representation, assurance or warranty made or given by any other
              party, except as expressly set out in this agreement.
            </li>
          </ol>

          <h4 className="text-lg lg:text-xl text-theme-teal  font-semibold ">
            <strong>21. WAIVERS</strong>
          </h4>
          <ol className="list text-base pl-4 font-light text-gray-400 leading-relaxed mb-6">
            <li>
              21.1 Waiver of any right, power, authority, discretion or remedy
              arising from any breach of this agreement must be in writing and
              signed by the party granting the waiver.
            </li>
            <li>
              21.2 A party is not entitled to rely on a delay in the exercise or
              non-exercise of a right, power, authority, discretion or remedy
              arising from a breach of this agreement or on a default under this
              agreement as constituting a waiver of that right, power,
              authority, discretion or remedy.
            </li>
            <li>
              21.3 A party may not rely on any conduct of the other party as a
              defence to exercise of a right, power, authority, discretion or
              remedy by that party.
            </li>
            <li>
              21.4 This clause may not itself be waived except by writing.
            </li>
          </ol>

          <h4 className="text-lg lg:text-xl text-theme-teal  font-semibold ">
            <strong>22. SEVERABILITY</strong>
          </h4>
          <ol className="list text-base pl-4 font-light text-gray-400 leading-relaxed mb-6">
            <li>
              22.1 If the whole or any part of a provision of this agreement is
              or becomes invalid or unenforceable under the Law of any
              jurisdiction, it is severed in that jurisdiction to the extent
              that it is invalid or unenforceable and whether it is in severable
              terms or not.
            </li>
            <li>
              22.2 Clause 22.1 does not apply if the severance of a provision of
              this agreement in accordance with that clause would materially
              affect or alter the nature or effect of the parties’ obligations
              under this agreement.
            </li>
          </ol>

          <h4 className="text-lg lg:text-xl text-theme-teal  font-semibold ">
            <strong>23. NOTICES</strong>
          </h4>
          <ol className="list text-base pl-4 font-light text-gray-400 leading-relaxed mb-6">
            <li>
              23.1 Notices under this agreement may be delivered by hand, by
              registered mail or by email to the following addresses:
            </li>
            <li>For us:</li>
            <li>Attn: Chief Financial Officer</li>
            <li>Nube iO Pty Ltd</li>
            <li>Email: accounts@nube-io.com</li>
            <li>Mail: Unit 1 / 17 Cemetery Road, Helensburgh NSW 2508</li>
            <li>For you:</li>
            <li>As notified in writing by you from time to time.</li>
            <li>23.2 Notice will be deemed given:</li>
            <li>
              23.2.1 in the case of hand delivery or registered mail, upon
              written acknowledgment of receipt by an officer or other duly
              authorised employee, agent or representative of the receiving
              party; and
            </li>
            <li>
              23.2.2 if it is sent by email, when the sender’s system registers
              that the email has passed the Internet gateway of the sender’s
              system (and no delivery failure or out of office message is
              received by the sender within 1 hour of sending).
            </li>
            <li>
              23.3 If such notice is deemed to have been duly given or made
              after 5.00 pm in the place to which such notice is addressed or on
              a day which is not a Business Day in that place, it will be deemed
              to be duly given or made at 9.00 am on the next Business Day in
              that place.
            </li>
          </ol>
          <h4 className="text-lg lg:text-xl text-theme-teal  font-semibold ">
            <strong>24. FORCE MAJEURE</strong>
          </h4>
          <ol className="list text-base pl-4 font-light text-gray-400 leading-relaxed mb-6">
            <li>
              Neither party will be liable for any delay or failure to perform
              its obligations under this agreement if such failure or delay is
              due to Force Majeure except that no obligation to make a payment
              will not be relieved by Force Majeure.
            </li>
          </ol>

          <h4 className="text-lg lg:text-xl text-theme-teal  font-semibold ">
            <strong>25. GOVERNING LAW</strong>
          </h4>
          <ol className="list text-base pl-4 font-light text-gray-400 leading-relaxed mb-6">
            <li>
              This agreement will be governed by and construed according to the
              laws of New South Wales.
            </li>
          </ol>

          <h4 className="text-lg lg:text-xl text-theme-teal  font-semibold ">
            <strong>26. DISPUTE RESOLUTION</strong>
          </h4>
          <ol className="list text-base pl-4 font-light text-gray-400 leading-relaxed mb-6">
            <li>
              26.1 If a dispute arises between the parties in connection with
              this agreement including any question regarding its existence,
              validity or termination (Dispute), a party may give to the other
              party a notice (Dispute Notice) specifying the Dispute.
            </li>
            <li>
              26.2 If the Dispute is not resolved within 10 Business Days after
              a Dispute Notice is given to the other party, each party must
              nominate one representative from its senior management with
              authority to resolve the Dispute.
            </li>
            <li>
              26.3 If the Dispute is not resolved within 15 Business Days of the
              Dispute being referred to the respective representatives, then
              either party may, after giving written notice to the other party,
              refer the Dispute to arbitration.
            </li>
            <li>
              26.4 Any Dispute that is not resolved in accordance with the
              clauses above, must be resolved by arbitration in accordance with
              theACICAArbitration Rules. The seat of arbitration will be Sydney,
              Australia. The language of the arbitration will be English. The
              number of arbitrators will be one.
            </li>
            <li>
              26.5 Nothing in this clause 26 prevents a party from seeking any
              urgent interim or interlocutory relief which may be required in
              relation to this agreement.
            </li>
            <li>
              26.6 During the existence of any Dispute, the parties must
              continue to perform all their obligations under this agreement
              without prejudice to their position in respect of such Dispute,
              unless the parties otherwise agree.
            </li>
          </ol>

          <h4 className="text-lg lg:text-xl text-theme-teal  font-semibold ">
            <strong>27. GLOSSARY</strong>
          </h4>
          <ol className="list text-base pl-4 font-light text-gray-400 leading-relaxed mb-6">
            <li>In this document, unless a contrary intention appears:</li>
            <li>
              <strong>Affiliate</strong>means a Related Body Corporate of an
              entity or an entity that Controls, is Controlled by or is under
              common Controlwith, the entity.
            </li>
            <li>
              <strong>Authorisation</strong>means:
            </li>
            <li>
              (a) An authorisation, consent, exemption or licence, however it is
              described, required to do something that would otherwise be
              prohibited or restricted by Law; or
            </li>
            <li>
              (b) In relation to something that could be prohibited or
              restricted by Law if a Government Agency acts in any way within a
              specified period, the expiry of that period without that action
              being taken.
            </li>
            <li>
              <strong>Business Day</strong>means a day on which banks are open
              for business in Sydney, New South Wales, other than a Saturday,
              Sunday or public holiday.
            </li>
            <li>
              <strong>Carriage Service</strong>has the meaning given in the
              Telecommunications Act 1997 (Cth).
            </li>
            <li>
              <strong>Carriage Service Provider</strong>has the meaning given in
              the Telecommunications Act 1997 (Cth).
            </li>
            <li>
              <strong>Carrier</strong>has the meaning given in the
              Telecommunications Act 1997 (Cth).
            </li>
            <li>
              <strong>Change of Control</strong>means, in relation to you, the
              occurrence of any of the following:
            </li>
            <li>(a) the sale of all or substantially all of your assets;</li>
            <li>
              (b) a change in your shareholding (provided that you are not
              listed on a recognised securities exchange) that results in a
              different person or group of persons having Control; or
            </li>
            <li>
              (c) a change in the shareholding of your holding company (provided
              that the holding company is not listed on a recognised securities
              exchange) that results in a different person or group of persons
              having Control.
            </li>
            <li>
              <strong>Charges</strong>means the prices, charges and fees that
              you must pay for the Products and the Services as specified in the
              applicable Product Descriptions or Services Descriptions or this
              agreement (including the monthly fixed fee for your selected Data
              Plan plus any excess usage fees and charge including those if you
              exceed the data allowance for the specified period) as adjusted or
              changed in accordance with this agreement.
            </li>
            <li>
              <strong>Claim</strong>means a cause of action, claim, demand, suit
              or proceeding of any kind, including by way of court proceedings,
              proceedings in the nature of arbitration, mediation or other
              methods of dispute resolution and administrative claims and
              proceedings (whether or not before a tribunal).
            </li>
            <li>
              <strong>Confidential Information</strong>means this agreement and,
              in the case of you, any information (in whatever form) or
              documentation which is marked as confidential and, in the case of
              us, any information (in whatever form) or documentation of a
              confidential nature (or which you or your personnel ought
              reasonably know to be confidential) that relates to our business,
              affairs or activities or our Affiliates and, in the case of you
              and us, which:
            </li>
            <li>
              (a) is disclosed to the other party by or on behalf of a party; or
            </li>
            <li>(b) is generated by us or our personnel.</li>
            <li>
              <strong>Control</strong>means having control of the composition of
              the board of directors or more than 50% of the shares giving a
              right to vote at general meetings and
              <strong>Controlled</strong>has a corresponding meaning.
            </li>
            <li>
              <strong>Corporations Act</strong>means the Corporations Act 2001
              (Cth).
            </li>
            <li>
              <strong>Control Centre</strong>means the SIM Control Centre portal
              we use to manage your SIM plan.
            </li>
            <li>
              <strong>Corporations Act</strong>means the Corporations Act 2001
              (Cth).
            </li>
            <li>
              <strong>Data Plan</strong>means a plan that we provide that allows
              you to use a fixed amountof data for a fixed price and period and
              includes an excess usage charge if you exceed the allowance for
              the following connectivity services:
            </li>
            <li>SaaS:</li>
            <li>
              (a)<strong>Data Hosting</strong>: Secure data storage and
              management of your data via our Australian-based outsourced data
              centres;
            </li>
            <li>
              (b)<strong>Visualization</strong>: The creation and maintenance of
              visual dashboards to assist you in understanding you data metrics;
              and
            </li>
            <li>Data Connectivity (4G):</li>
            <li>
              (c) Enable mobile fourth-generation wireless (4G) data flow, the
              stage of broadband mobile communications via an Australian
              telecommunication network provider
            </li>
            <li>
              <strong>Default</strong>means an act or omission that:
            </li>
            <li>(a) is a contravention of a written Law; or</li>
            <li>
              (b) amounts to negligence or a breach of a duty (including a duty
              arising under an agreement) or a breach of an agreement or other
              document.
            </li>
            <li>
              <strong>Dispute</strong>has the meaning given to it in clause 26
              (Dispute Resolution).
            </li>
            <li>
              <strong>Dispute Notice</strong>has the meaning given to it in
              clause 26 (Dispute Resolution).
            </li>
            <li>
              <strong>Force Majeure</strong>meansfire, storm, flood, earthquake,
              explosion, accident, acts of a public enemy, terrorist acts, war,
              rebellion, insurrection, sabotage, epidemic, quarantine
              restriction, transportation embargo, strikes and any other event
              which is outside the reasonable control of the relevant party.
            </li>
            <li>
              <strong>Government Agency</strong>means any government or
              governmental, administrative, monetary, fiscal or judicial body,
              department, commission, authority, tribunal, agency or entity.
            </li>
            <li>
              <strong>GST Act</strong>means the A New Tax System (Products and
              Services Tax) Act 1999 (Cth).
            </li>
            <li>
              <strong>GST Law</strong>has the meaning given to that term in the
              GST Act.
            </li>
            <li>
              <strong>Insolvency Event</strong>means:
            </li>
            <li>
              (a) becoming bankrupt or insolvent within the meaning of section
              95A(2) of the Corporations Act or section 5 of the Bankruptcy Act
              1966 (Cth) (as applicable);
            </li>
            <li>
              (b) committing an act of bankruptcy within the meaning of section
              40 of the Bankruptcy Act 1966 (Cth) or making a compromise or
              composition or assignment of property in favour of creditors;
            </li>
            <li>
              (c) having a liquidator, provisional liquidator, administrator,
              receiver, manager, or receiver and manager appointed;
            </li>
            <li>
              (d) having any meeting called for the consideration of, or any
              resolution passed, or any application made, any petition filed,
              any order made or any direction given for any of the above
              appointments; or
            </li>
            <li>
              (e) something having a substantially similar effect to paragraphs
              (a) to (d) occurring under the Law of any jurisdiction.
            </li>
            <li>
              <strong>IP or Intellectual Property</strong>means all present and
              future copyright and all rights in relation to inventions
              (including patent rights), registered and unregistered trademarks
              (including service marks), registered and unregistered designs,
              and circuit layouts, and any other rights resulting from
              intellectual activity in the industrial, scientific, literary and
              artistic fields recognised in domestic law anywhere in the world.
            </li>
            <li>
              <strong>Loss</strong>means any liability, loss, damage,
              compensation and costs and expenses (including the costs of the
              investigation, defence and settlement of any Claim or demand) and
              any legal costs and expenses in relation thereto on a solicitor
              and own client basis.
            </li>
            <li>
              <strong>Moral Right</strong>means a right conferred by Part IX of
              the Copyright Act 1968 (Cth) and a right of a similar nature
              conferred by statute that exists, or may come to exist, anywhere
              in the world.
            </li>
            <li>
              <strong>Order</strong>means a request by you for a Product or a
              Service or a change to a Service that we have accepted in
              accordance with this agreement.
            </li>
            <li>
              <strong>Our Policies</strong>means our policies that are described
              on Our Website, including our access and acceptable use policy.
            </li>
            <li>
              <strong>Our System</strong>means the system of computer equipment,
              software, processes and interfaces that comprises the
              infrastructure used by us to provide the Services, including Our
              Website, the Services Portal and the Control Centre. To avoid
              doubt, this does not includeinfrastructure used by a Carrier or
              Carriage Services Provider to supply a Carriage Service to you or
              us.
            </li>
            <li>
              <strong>Our Warranty Policy</strong>means the Warranty Policy on
              Our Website.
            </li>
            <li>
              <strong>Our Website</strong>means our website at
              https://nube-io.com or https://enviroservices.com.au
            </li>
            <li>
              <strong>PPSA</strong>means the Personal Property Securities Act
              2009 (Cth).
            </li>
            <li>
              <strong>Product</strong>means a product that we will supply to you
              under this agreement as specified in an Order.
            </li>
            <li>
              <strong>Product Description</strong>means, in respect of a Product
              we supply, the description of that Product on Our Website.
            </li>
            <li>
              <strong>Related Body Corporate</strong>has the meaning given to
              that term in the Corporations Act.
            </li>
            <li>
              <strong>Security Interest</strong>has the meaning given to that
              term in the PPSA.
            </li>
            <li>
              <strong>Service Level</strong>means the standards of service we
              try to attain in supplying Services as specified in the Services
              Description, including availability times and response times.
            </li>
            <li>
              <strong>Service</strong>means a service that we will supply to you
              under this agreement as specified in an Order.
            </li>
            <li>
              <strong>Services Description</strong>means, in respect of a
              service we supply, labour, engineering services, management and
              consulting, electrical trades (installation and commissioning) and
              any Data Plan selected by you.
            </li>
            <li>
              <strong>SIM Card</strong>means a subscriber identity module card
              that may be fitted to or removed from a device by hand.
            </li>
            <li>
              <strong>Supplier</strong>means a person who supplies Products to
              us on terms that we may resupply the Products to third parties,
              including you.
            </li>
            <li>
              <strong>Support Portal</strong>means the support portal we make
              available to you on Our Website.
            </li>
            <li>
              <strong>Virus</strong>means:
            </li>
            <li>
              (a) any program code, programming instruction or set of
              instructions intentionally constructed to damage, interfere with
              or otherwise adversely affect computer programs, data files or
              operations;
            </li>
            <li>
              (b) any device that would, if introduced into a system or software
              used to provide the Products or the Services, prevent that system
              or software from performing the functions it is designed to
              perform, or interfere with or otherwise adversely affect that
              performance; or
            </li>
            <li>
              (c) any other code or device which a person in the IT industry
              would reasonably consider to be a virus.
            </li>
            <li>
              <strong>we or us</strong>means Enviro Building Services: 11 130
              324 748/Nube iO Operations: 18 629 763 177/Nube iO Pty Ltd: 56 623
              130 512].
            </li>
            <li>
              <strong>you</strong>means the customer.
            </li>
          </ol>
        </div>
        <div className="my-6 w-full border-t-2 border-theme-teal dark:border-gray-300 mt-12" />
      </div>
    </section>
  );
}
